import NavItem from './nav-link';

export default function NoResults({
                                      title = 'NO EVENTS CURRENTLY SCHEDULED',
                                      subtitle = 'Our team are currently planning the next set of events to star at the DMC.',
                                      content = 'Do you want to keep in the know with events and all things DMC?',
                                        slug = '#joinus',
                                        onClick = null
                                  }) {
    return (
        <div className="no-results">
            <div className="no-results__left">
                <h1>{title}</h1>
            </div>
            <div className="no-results__right">
                <h2> {subtitle} </h2>
                <p>{content}</p>
                <NavItem onClick={onClick} slug={slug} text="Join our mailing list" color="yellow"/>
            </div>
        </div>
    )
}
